import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { ADD_QUEUE_POSITION } from "./actionTypes";
import { addQueuePositionSuccess, addQueuePositionError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* addQueuePosition({ payload: { ws_pos, queue_init, queue_end, confirmation_point, token, history } }) {
  try {
    const response = yield call(workstationAPI.addQueues, ws_pos, queue_init, queue_end, confirmation_point, token);
    yield put(addQueuePositionSuccess(response.message, response.addedQueue));
    history.go();
  } catch (error) {
    yield put(addQueuePositionError(error));
  }
}

export function* watchAddQueuePosition() {
  yield takeEvery(ADD_QUEUE_POSITION, addQueuePosition);
}

function* AddQueuePositionSaga() {
  yield all([fork(watchAddQueuePosition)]);
}

export default AddQueuePositionSaga;
